export const LOGO_SVG = "/logo.svg";
export const LOGO_PNG = "/logo.png";